import { useEffect, useMemo, useState } from "react";

export const ANALYTICS_FILTER_KEY = "bv1_analytics_filters";

const LEGACY_FILTER_KEYS = [
  "overview_dashboard_filters",
  "finance_dashboard_filters",
  "finance_expense_analytics_filters",
  "sales_funnel_filters",
  "traffic_attribution_filters",
];

const readStoredFilters = () => {
  const current = sessionStorage.getItem(ANALYTICS_FILTER_KEY);
  if (current) {
    try {
      return JSON.parse(current);
    } catch {
      /* ignore */
    }
  }

  for (const key of LEGACY_FILTER_KEYS) {
    const legacy = sessionStorage.getItem(key);
    if (!legacy) continue;
    try {
      const parsed = JSON.parse(legacy);
      sessionStorage.setItem(ANALYTICS_FILTER_KEY, legacy);
      return parsed;
    } catch {
      /* ignore */
    }
  }

  return null;
};

export default function useAnalyticsFilters(defaultRange = "thisMonth") {
  const [dateRange, setDateRange] = useState(defaultRange);
  const [customRange, setCustomRange] = useState({ start: null, end: null });
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const saved = readStoredFilters();
    if (saved) {
      setDateRange(saved.dateRange || defaultRange);
      if (saved.dateRange === "custom" && saved.customRange) {
        setCustomRange(saved.customRange);
      }
    }
    setHydrated(true);
  }, [defaultRange]);

  useEffect(() => {
    if (!hydrated) return;
    sessionStorage.setItem(
      ANALYTICS_FILTER_KEY,
      JSON.stringify({ dateRange, customRange })
    );
  }, [dateRange, customRange, hydrated]);

  const filters = useMemo(
    () => ({
      dateRangeType: dateRange,
      customDateRange:
        dateRange === "custom" && customRange.start && customRange.end
          ? [customRange.start, customRange.end]
          : null,
    }),
    [dateRange, customRange]
  );

  return {
    filters,
    dateRange,
    setDateRange,
    customRange,
    setCustomRange,
    hydrated,
  };
}
